export default "__VITE_ASSET__BrbSewQj__"